import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';

@Component({
  selector: 'app-employee-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule
  ],
  templateUrl: './employee-dashboard.component.html',
  styleUrls: ['./employee-dashboard.component.css']
})
export class EmployeeDashboardComponent {
  stats = [
    { title: 'Total Sales', value: '₹1,20,000', icon: 'shopping_cart', color: '#1976d2' },
    { title: 'New Orders', value: '120', icon: 'receipt', color: '#43a047' },
    { title: 'Pending Payments', value: '₹45,000', icon: 'payment', color: '#fbc02d' },
    { title: 'Customers', value: '540', icon: 'people', color: '#e53935' }
  ];

  displayedColumns: string[] = ['id', 'name', 'status', 'amount', 'action'];
  dataSource = [
    { id: 1, name: 'Order #1001', status: 'Completed', amount: '₹2,500' },
    { id: 2, name: 'Order #1002', status: 'Pending', amount: '₹5,000' },
    { id: 3, name: 'Order #1003', status: 'Shipped', amount: '₹1,200' },
    { id: 4, name: 'Order #1004', status: 'Completed', amount: '₹7,800' }
  ];
}
